import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/android-chrome-192x192.png" alt="NinjaCopia" className="w-8 h-8" />
              <span className="font-bold text-xl text-gray-900 dark:text-white">NinjaCopia</span>
            </div>
            <p className="text-gray-600 dark:text-gray-400 mb-4 max-w-md">
              Professional multi-account trade copying for NinjaTrader. Execute once, replicate everywhere with &lt;5ms latency.
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-500 mb-2">
              NinjaTrader® is a registered trademark of NinjaTrader Group, LLC. NinjaCopia is an independent product and is not endorsed by or affiliated with NinjaTrader Group, LLC.
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-500">
              NinjaCopia requires NinjaTrader 8 and compatible data feed/broker connection.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/features" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/links" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Links
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/risk-disclosure" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Risk Disclosure
                </Link>
              </li>
              <li>
                <Link to="/hypothetical-disclaimer" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                  Hypothetical Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Partners Section */}
        <div className="border-t border-gray-200 dark:border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <span className="text-sm text-gray-500 dark:text-gray-400">Powered by</span>
            <a href="https://ninjatraderdomesticvendor.sjv.io/Dyjebd" target="_blank" rel="noopener noreferrer" className="flex items-center">
              <img src="/images/ninjatrader-logo.png" alt="NinjaTrader" className="h-8" />
            </a>
            <a
              href="http://kinetick.com/NinjaTrader"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
            >
              Kinetick Market Data
            </a>
          </div>
        </div>

        {/* Risk Disclosure Section */}
        <div className="border-t border-gray-200 dark:border-gray-700 mt-8 pt-8">
          <div className="text-[11px] text-gray-500 dark:text-gray-500 leading-relaxed space-y-4 max-w-4xl mx-auto">
            <div>
              <h4 className="font-semibold text-gray-600 dark:text-gray-400 mb-1">Risk Disclosure</h4>
              <p>
                Futures and forex trading contains substantial risk and is not for every investor. An investor could potentially lose all or more than the initial investment. Risk capital is money that can be lost without jeopardizing one's financial security or lifestyle. Only risk capital should be used for trading and only those with sufficient risk capital should consider trading. Past performance is not necessarily indicative of future results.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-gray-600 dark:text-gray-400 mb-1">Hypothetical Performance Disclaimer</h4>
              <p>
                Hypothetical performance results have many inherent limitations, some of which are described below. No representation is being made that any account will or is likely to achieve profits or losses similar to those shown; in fact, there are frequently sharp differences between hypothetical performance results and the actual results subsequently achieved by any particular trading program. One of the limitations of hypothetical performance results is that they are generally prepared with the benefit of hindsight. In addition, hypothetical trading does not involve financial risk, and no hypothetical trading record can completely account for the impact of financial risk of actual trading. For example, the ability to withstand losses or to adhere to a particular trading program despite trading losses are material points that can also adversely affect actual trading results. There are numerous other factors related to the markets in general or to the implementation of any specific trading program that cannot be fully accounted for in the preparation of hypothetical performance results and all which can adversely affect trading results.
              </p>
            </div>
            <div className="pt-2">
              <a
                href="https://docs.google.com/document/d/1H-ft0gQzTMM8YZSpV3SzcORuLXLyQa-KN6AAslgcQC0/edit"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:underline font-medium"
              >
                Full Risk Disclosure →
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-500 dark:text-gray-400">
            © 2025 NinjaCopia. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;